/* eslint-disable max-len */
export default {
  cfmoto: {
    AIReview: 'Przegląd AI',
    AIReviewFailed: 'Przegląd AI nie powiódł się',
    AIReviewPassed: 'Przegląd AI zaliczony',
    AIReviewStatus: 'Status przeglądu AI',
    AIReviewing: 'Przegląd AI jest sprawdzany',
    America: {},
    CheckSupportInstall: 'Sprawdź, czy wspierane jest modernizacja',
    ImporterCommunityDisplayName: 'Wyświetlana nazwa importera w społeczności',
    ImporterContactEmail: 'Kontaktowy adres e-mail importera',
    IndicatorLight: 'lampka sygnalizacyjna',
    Instruction: 'Ogłoszenie',
    MostPicture4OrVideo: '(Maksymalnie 4 zdjęcia / 1 film)',
    PleaseContactPersonnelCommunicating: 'Skontaktuj się z personelem CFMOTO w celu komunikacji',
    Redemptionservice: 'Usługa w ramach wymiany',
    USD: {},
    UnbindingApplicationCommitment: {},
    aboutAccount: 'Informacje o koncie',
    aboutVehicle: 'Informacje o pojeździe',
    accountApplyRejected: 'Żądanie usunięcia konta odrzucone',
    accountCancel: 'Żądanie usunięcia konta',
    accountDeletExplain: 'Wskazówki dotyczące usuwania konta',
    accountDelete: 'Usuwanie konta',
    accountDeleted: 'Konto usunięte',
    accountFormatError: 'Nieprawidłowy format konta/użytkownik nie istnieje. Prosimy o dopasowanie odpowiedniego copywritingu w oparciu o rzeczywistą przyczynę',
    accountNumber: 'Numer konta',
    action: 'Operacja',
    actionFail: 'operacja nie powiodła się',
    actionSuccess: 'Operacja zakończona powodzeniem',
    activeScore: 'Aktywne punktowanie',
    activeTrigger: 'Użytkownicy aktywnie wyzwalają (Informacje o aplikacji — przejdź do oceny)',
    activity: 'Aktywność',
    activityCancel: 'Anulowanie wydarzenia',
    activityCover: 'Okładka aktywności',
    activityDetails: 'Szczegóły wydarzenia',
    activityId: 'ID aktywności',
    activityList: 'Lista działań',
    activityManagement: 'Zarządzanie aktywnością',
    activitySearch: 'Wyszukiwanie aktywności',
    activityTime: 'Czas aktywności',
    activityTitle: 'Tytuł działania',
    activityVenue: 'Miejsce aktywności',
    adaptable: 'Złączki do',
    add: 'Dodaj',
    addAccountDeletExplain: 'Dodawanie powiadomienia o usunięciu konta',
    addAuthenticationTime: 'Dodaj czas uwierzytelniania',
    addCanadaPrivacyPolicy: 'Dodaj Politykę prywatności Kanady',
    addCanadaTelematicsPolicy: 'Dodaj kanadyjską umowę telematyczną',
    addCanadaUserPolicy: 'Dodaj kanadyjską umowę użytkownika',
    addDashcamHelp: 'Dodano pomoc dotyczącą kamery samochodowej',
    addDataDeletExplain: 'Dodaj powiadomienie o usunięciu danych',
    addEmail: 'Nowy e-mail',
    addExhibitionCategory: {},
    addExhibitionSeries: {},
    addHelpConfiguration: 'Dodawanie instrukcji pomocy dotyczących konfiguracji',
    addInformationCategory: 'Dodaj nową kategorię informacji',
    addInformationContent: 'Dodaj nową treść informacyjną',
    addKolUserAuthentication: 'Dodaj uwierzytelnianie użytkownika KOL',
    addPicture: 'Dodaj zdjęcie',
    addPrivacyAgreement: 'Dodaj umowę o ochronie prywatności',
    addPrivacySubmitSure: 'Po przesłaniu nie ma możliwości zmiany daty wejścia w życie oraz opisu zmiany nowej polityki prywatności. Potwierdź przesłanie.',
    addPushConfiguration: 'Dodaj przycisk konfiguracji',
    addQuestion: {},
    addSdkStaement: 'Dodaj instrukcję SDK',
    addServiceIntroduce: 'Wprowadzenie do nowych usług',
    addShowroomModel: 'Dodaj modele salonu',
    addThisUser: 'Dodaj tego użytkownika',
    addTopic: 'Dodaj temat',
    addUser: 'Dodaj użytkownika',
    addUserAgreement: 'Dodaj umowę użytkownika',
    addUserRole: 'Dodaj rolę użytkownika',
    addVehicleModel: 'Nowe modele',
    addVehicleModelCategory: 'Nowa kategoria pojazdów',
    addVideo: 'Dodaj wideo',
    addedBy: 'Dodane przez',
    additionalFeedback: 'Dodatkowe informacje zwrotne',
    administratorUnbind: 'Administrator odblokuj',
    afternoon: 'Popołudnie',
    agreeServiceAgreement: 'Aktywując usługę, akceptujesz Warunki świadczenia usług',
    agreeSignOut: 'Zgoda na rozwiązanie umowy',
    agreementContent: 'Porozumienie',
    all: 'Cały',
    allArea: 'Docelowy kraj/region',
    allComment: 'Wszystkie komentarze',
    allImportSuccess: 'Import zakończony. Wszystko zostało pomyślnie zaimportowane',
    allServicesSimultaneously: 'Wszystkie usługi',
    allUser: 'Wszyscy użytkownicy',
    allVehicleModel: 'Wszystkie modele',
    alreadyOver: 'Wszystko tutaj',
    ambientLightControl: 'Sterowanie oświetleniem ambientowym',
    amount: 'Kwota',
    android: 'Android',
    answer: {},
    answerOta1: 'OTA oznacza, że pojazd pobiera najnowsze oprogramowanie układowe z chmury za pośrednictwem sieci komórkowej, a pojazd można aktualizować online za pośrednictwem CFMOTO RIDE, aby stale optymalizować wrażenia z jazdy',
    answerOta2: 'Gdy będzie można zaktualizować nową wersję wyświetlacza TFT, otrzymasz powiadomienie o aktualizacji. Jeśli na dole bieżącej strony wyświetlany jest %s, oznacza to, że wyświetlacz TFT pojazdu nie wymaga aktualizacji.',
    answerOta3: 'Możesz kliknąć %s w prawym górnym rogu, aby wcześniej dowiedzieć się więcej instrukcji obsługi OTA',
    anyCar: 'Jakikolwiek samochód?',
    appMessagePushCountLimit: 'Osiągnąłeś limit powiadomień push na ten miesiąc (2 razy/miesiąc). Edytowana treść może zostać zapisana jako szkic. Czy chcesz ją zapisać?',
    appPush: 'Powiadomienie w aplikacji',
    appRating: 'Zarządzanie mechanizmem scoringowym',
    appType: 'System telefoniczny',
    appVersion: 'Wersja aplikacji',
    applicableCountry: {},
    applicableCountryName: {},
    applyTime: 'Czas aplikacji',
    applyUnbinding: 'Zastosuj odblokowanie',
    appointmentReleaseTime: 'Termin zwolnienia terminu',
    approval: 'Aprobata',
    arrivalNumberDescription: 'Liczba urządzeń, które otrzymały powiadomienie',
    arrivalNumberDescription0: 'Rzeczywista liczba przybyć do terminala urządzenia po wysłaniu powiadomienia (przybycia po 5 dniach nie będą liczone).',
    arrivalNumberVolume: 'Liczba przylotów',
    askAllowUserSpeakInCommunity: 'Czy chcesz zezwolić zablokowanemu użytkownikowi na publikowanie w społeczności',
    askApproveIt: 'Czy chcesz zatwierdzić',
    askDeleteCategory: {},
    askDeleteInformactionCategory: 'Czy usunąć tę kategorię informacji',
    askDeleteInformationContent: 'Czy usunąć zawartość informacyjną',
    askDeleteKolUserAuthentication: 'Czy na pewno chcesz usunąć uwierzytelnienie użytkownika KOL?',
    askDeleteOfficialAuth: 'Czy na pewno chcesz usunąć oficjalne uwierzytelnienie dla tego konta?',
    askDeleteQuestion: {},
    askDeleteThisActivity: 'Czy chcesz usunąć tę aktywność',
    askDeleteThisBanner: 'Czy chcesz usunąć ten baner',
    askDeleteThisComment: 'Czy na pewno chcesz usunąć ten komentarz',
    askDeleteThisPost: 'Czy chcesz usunąć ten post',
    askDeleteThisTopic: 'Czy chcesz usunąć ten temat',
    askDeleteVehicleType: 'Czy na pewno usunąć model pojazdu',
    askDeleteVehicleTypeCategory: 'Określa, czy usunąć tę kategorię modelu',
    askDeleteVehicleTypeDetails: 'Czy usunąć szczegóły modelu samochodu',
    askDeleteVehicleTypeSeries: 'Czy usunąć tę serię modelu',
    askLogout: 'Czy na pewno chcesz wyjść z systemu?',
    askNotApproveIt: 'Czy nie chcesz zatwierdzić',
    askSaveSettings: 'Подешавања још увек нису сачувана, да ли желите да их сачувате?',
    associatedPostNumber: 'Liczba powiązanych postów',
    associatedPosts: 'Powiązane posty',
    associatedVehicle: 'powiązany pojazd',
    assoclatedContent: 'Powiązane treści',
    atmosphereCContent: 'Подешавања још увек нису сачувана, да ли желите да их сачувате?',
    atmosphereContent1Msg1: 'Po włączeniu funkcji telefon komórkowy włącza Bluetooth, a aplikacja nadal działa. Podchodząc do pojazdu z daleka do bliży, pojazd można automatycznie odblokować i włączyć.',
    atmosphereContent1Msg2: 'Jeśli normalnie nie jest odblokowany i włączony, naciśnij przycisk zasilania pojazdu, aby odblokować i włączyć',
    atmosphereContent1Msg3: 'Automatyczne odblokowanie zbliżeniowe zostanie uruchomione tylko raz przed odłączeniem Bluetooth',
    atmosphereContent2Msg1: 'Po włączeniu funkcji pojazd automatycznie wyłączy się po 5 sekundach po trzech warunkach wyłączenia pojazdu, prędkość pojazdu wynosi 0 i świątynia jest opuszczona',
    atmosphereContent2Msg2: 'Uruchomienie pojazdu w okresie automatycznego wyłączania, prędkość pojazdu nie wynosi 0 lub odłożenie skroni spowoduje anulowanie automatycznego wyłączania',
    atmosphereContent3Msg1:
      'Po włączeniu funkcji, gdy pojazd jest wyłączony, telefon komórkowy włącza Bluetooth, a aplikacja nadal działa lub nosi fizyczny klucz. Podczas zbliżania się do pojazdu z daleka do bliży światła pojazdu będą migać na powitanie gości',
    atmosphereContent3Msg2: 'Aby zapobiec częstym wyzwalaczom powodującym utratę mocy pojazdu, po dwukrotnym uruchomieniu funkcji powitalnej w ciągu 30 sekund, zostanie ona wznowiona dopiero 30 minut później',
    atmosphereContent4Msg1: 'Po włączeniu funkcji światła drogowe i mijania zostaną włączone automatycznie na 10 sekund po wyłączeniu pojazdu',
    atmosphereIntroduce1: 'Blisko instrukcji automatycznego odblokowania',
    atmosphereIntroduce2: 'instrukcje automatycznego wyłączania',
    atmosphereIntroduce3: 'Instrukcje automatycznego budzenia',
    atmosphereIntroduce4: 'Opóźnione wyłączanie świateł',
    atmosphereSetINfo: 'Нова подешавања ће ступити на снагу у року од 1-3 минута након што се возило укључи, уверите се да је возило у добром сигналном положају',
    auditStatus: 'Status przeglądu',
    authType: 'Typ uwierzytelnienia',
    authenticatedName: 'Nazwa uwierzytelnienia',
    avatar: 'Awatara',
    backApply: 'wycofać wniosek',
    backApplySuccess: 'wycofanie wniosku zakończyło się sukcesem',
    backHome: 'Powrót do strony głównej',
    bannerDisplayImages: 'Obraz banera',
    bannerList: 'Lista banerów',
    bannerManagement: 'Zarządzanie banerami',
    bannerPictrure: 'Rysunek banera',
    bannerSearch: 'Wyszukiwanie banerów',
    bannerTitle: 'Tytuł banera',
    baseService: 'Standard Edition\n',
    baseServicePay: 'Płatność za Standard Edition',
    baseServiceResetTimeRule: 'Czas resetu usług podstawowych nie może być późniejszy niż bieżący czas',
    batchImport: 'Import wsadowy',
    batchUser: 'Użytkownicy wsadowi',
    beijingTime: 'Czas UTC+8',
    belogCategory: 'Kategoria',
    belongCategory: {},
    bindDevice: 'Zwiąż urządzenie',
    bindEmail: 'Powiąż email',
    bindVehicle: 'Zwiąż pojazd',
    bindingStatus: 'Stan wiązania',
    bindingText1: '1.\tUsługi telematyczne',
    bindingText10: '1.1.2.\tZapewnienie planowania trasy podczas nawigacji, w tym obliczania odległości między pojazdami i nawigacji pieszej w celu znalezienia pojazdu .',
    bindingText11: '1.2.\tWysyłanie niezbędnych powiadomień do Klienta w oparciu o stan pojazdu.',
    bindingText12:
      '1.2.1.\tCFMOTO będzie przesyłać Klientowi powiadomienia dotyczące konserwacji pojazdu (np. na podstawie całkowitej odległości przebytej przez Klienta, czasu zakupu pojazdu przez Klienta, wymaganego czasu lub odległości wymaganej do konserwacji pojazdu) .',
    bindingText13: '1.2.2.\tW oparciu o dane pojazdu , CFMOTO wyśle Klientowi powiadomienia o nietypowych sytuacjach; w tym analiza danych przez OEM (w zależności od modelu) w celu zapewnienia obsługi klienta i dalszej optymalizacji pojazdu .',
    bindingText14: '1.3.\tWsparcie w analizie przyczyny wypadku w przypadku zgłoszenia przez Klienta poważnego wypadku Pojazdu.',
    bindingText15:
      '1.3.1.\tW przypadku poważnego wypadku Pojazdu, np. gdy Pojazd wywróci się lub przewróci na bok podczas jazdy, CFMOTO wesprze Klienta na żądanie w wyjaśnieniu, czy wypadek był spowodowany wadą Pojazdu, czy też innymi okolicznościami. Żądanie składane jest do CFMOTO przez Klienta za pośrednictwem lokalnego dystrybutora/partnera handlowego wskazanego w Umowie Sprzedaży Pojazdu.',
    bindingText16: '1.3.2.\tO ile pozwalają na to dostępne dane, CFMOTO oceni dane w odniesieniu do przyczyny wypadku i przekaże Klientowi odpowiedni raport.',
    bindingText17: '1.4.\tPomoc Klientowi w odzyskaniu Pojazdu po utracie Pojazdu .',
    bindingText18:
      '1.4.1.\tJeśli Pojazd zostanie zgubiony, CFMOTO dostarczy Klientowi dane dotyczące lokalizacji Pojazdu i inne przydatne dane o stanie Pojazdu (takie jak lokalizacja ostatniej aktywacji, aktualny stan pojazdu itp.) na żądanie i jeśli będą dostępne.',
    bindingText19: '1.4.2.\tŻądanie składane jest do CFMOTO przez Klienta za pośrednictwem lokalnego dystrybutora/partnera handlowego wskazanego w Umowie Sprzedaży Pojazdu.',
    bindingText2:
      'telematyczne pojazdu klientowi, który kupił pojazd CFMOTO (dalej „Klientowi” ). W ramach tych usług CFMOTO wykorzystuje dane zarejestrowane przez Pojazd na temat Pojazdu i jego zachowania podczas jazdy w odpowiednim okresie czasu. Szczegółowo dotyczy to następujących danych:',
    bindingText20: '1.5.\tZgłaszanie problemów posprzedażowych .',
    bindingText21: '1.5.1.\tCFMOTO zbiera zdalnie powiadomienia o kodach błędów wysyłane przez Pojazd w przypadku nieprawidłowego działania jego podzespołów i przekazuje odpowiednie informacje na żądanie Klienta bezpośrednio do Klienta.',
    bindingText22: '1.5.2.\tŻądanie składane jest do CFMOTO przez Klienta za pośrednictwem lokalnego dystrybutora/partnera handlowego wskazanego w Umowie Sprzedaży Pojazdu.',
    bindingText23: '2.\tOgraniczenia i wyłączenia usługi',
    bindingText24: '2.1.\tWyraźnie wskazuje się, że strukturalne lub inne zmiany techniczne w Pojeździe mogą ograniczyć lub nawet uniemożliwić świadczenie usług, ponieważ świadczenie usług jest uzależnione od prawidłowego podania danych pojazdu.',
    bindingText25: '2.2.\tW przypadku, gdy takie usługi nie mogą być świadczone z powodu działania danych lub sieci telekomunikacyjnych osób trzecich , jakakolwiek odpowiedzialność CFMOTO jest wyłączona.',
    bindingText26: '3.\tPrywatność',
    bindingText27:
      'CFMOTO będzie przestrzegać obowiązujących przepisów o ochronie danych podczas przetwarzania danych osobowych w związku z pojazdem CFMOTO . Warunki polityki prywatności C FMOTO są określone w tej aplikacji CFMOTO RIDE . Jako dodatek do polityki prywatności , t jego zawiadomienie jest zgodne z polityką prywatności . Klient może zapoznać się z polityką prywatności w przypadku niektórych treści związanych z przetwarzaniem danych, których nie obejmuje niniejsza informacja.',
    bindingText28: '4.\tObsługa klienta',
    bindingText29:
      '4.1.\tKlient może przesyłać pytania, komentarze lub wątpliwości dotyczące prywatności na adres CFMOTORIDEAPP@cfmotousa.com lub pisać na adres: CFMOTO Powersports, Inc., 3555 Holly Lane North, Suite 30, Plymouth, M N 55447. Klient może również zadzwonić Relacje z klientami CFMOTO pod numerem (888) 823-6686. ',
    bindingText3: 'Dane dotyczące zachowania użytkownika podczas jazdy : w tym przyspieszenie, opóźnienie, prędkość, zakręt, czas ostatniej jazdy i przebieg ostatniej jazdy .',
    bindingText30: '5.\trewizje _',
    bindingText31: '5.1.\tCFMOTO zastrzega sobie prawo do zmiany tego powiadomienia w dowolnym momencie, ale opublikujemy poprawki na CFMOTO RIDE Aplikacji i/lub powiadomić, zanim to zrobimy.',
    bindingText4:
      'Dane o stanie pojazdu: odnoszą się do stanu pojazdu w czasie rzeczywistym, w tym trybu jazdy, pozostałego paliwa, chwilowego zużycia paliwa, przebiegu, biegu pojazdu w czasie rzeczywistym, prędkości obrotowej silnika, ciśnienia w oponach, temperatury opon, danych dotyczących napięcia aktywacji akumulatora , temperatura płynu chłodzącego, stan blokady elektronicznej, wersja oprogramowania urządzenia inteligentnego, siła sygnału urządzeń inteligentnych, aktualne ustawienie deski rozdzielczej.',
    bindingText5:
      'Dane alarmowe pojazdu: dane alarmowe do wysłania, jeśli określone dane przekroczą ustaloną wartość, takie jak temperatura silnika, nadmierna prędkość, zbyt długi czas jazdy, wysoka temperatura płynu chłodzącego, nieprawidłowy ruch pojazdu, nieprawidłowe ciśnienie w oponach, wibracje, zrzut, kolizja itp . .',
    bindingText6: 'Informacje o usterkach pojazdu: odnoszą się do kodów usterek zgłaszanych przez każdą wewnętrzną część pojazdu.',
    bindingText7: 'Dane o lokalizacji pojazdu: odnoszą się do określonej lokalizacji geograficznej pojazdu.',
    bindingText8: '1.1.\tZapewnienie inż Klientowi usługi związane z pojazdami za pośrednictwem APLIKACJI CFMOTO RIDE .',
    bindingText9: '1.1.1.\tKonsumenci mogą zdalnie zarządzać pojazdami za pośrednictwem aplikacji CFMOTO RIDE APP (w tym wyświetlać lokalizację pojazdu, ustawiać informacje i funkcje pojazdu, zdalne sterowanie stanem pojazdu itp.).',
    bindingUser: 'Powiąż użytkownika',
    bothServices: 'Obie usługi',
    bound: 'Uwiązany',
    businessType: 'Typ działalności',
    button: 'Przycisk',
    callbackedApply: 'Wycofałeś wniosek o usunięcie konta w dniu yyyy-MM-dd HH:mm:ss',
    callbackedApplySyncTip:
      'Żądanie usunięcia konta zostało przesłane w dniu rrrr-MM-dd GG:mm:ss.  Trwale usuniemy konto użytkownika i powiązane z nim dane 15 dni po otrzymaniu wniosku.  Po usunięciu użytkownik nie będzie już mógł korzystać z usługi CFMOTO RIDESYNC.  Aby anulować usunięcie konta, należy ponownie stronę internetową lub zalogować się do aplikacji w ciągu 15 dni w celu wycofania żądania usunięcia konta.',
    callbackedApplyTip:
      'Żądanie usunięcia konta zostało przesłane w dniu rrrr-MM-dd GG:mm:ss.  Trwale usuniemy konto użytkownika i powiązane z nim dane 15 dni po otrzymaniu wniosku.  Po usunięciu użytkownik nie będzie już mógł korzystać z usługi CFMOTO RIDE.  Aby anulować usunięcie konta, należy ponownie stronę internetową lub zalogować się do aplikacji w ciągu 15 dni w celu wycofania żądania usunięcia konta.',
    canadaPrivacyPolicy: 'Polityka prywatności Kanady',
    canadaTelematicsPolicy: 'Kanadyjska Umowa Telematyczna',
    canadaUserPolicy: 'Kanadyjska Umowa Użytkownika',
    canadianAgreementText: 'Tekst umowy kanadyjskiej',
    cancel: 'Anuluj',
    cancellationAgreement: 'Umowa o anulowanie',
    cancelled: 'Odwołany',
    carOwner: 'Właściciel',
    carUserScore: 'Oceny właścicieli pojazdów',
    cardPass: 'Pomyślna weryfikacja tożsamości!',
    cfmotoName: 'CFMOTO',
    changeCodeValidate: 'Przełącz na uwierzytelnianie kodem weryfikacyjnym',
    changeDescriptionType: 'Zmień opis',
    changeDescriptionTypeSelectNo: 'Nie wiąże się ze zmianami przepisów dotyczących przetwarzania danych osobowych',
    changeDescriptionTypeSelectYes: 'Zmiany przepisów dotyczących przetwarzania danych osobowych',
    changeEmail: 'Zmień email',
    changeEmailInfo: 'Przełącz na pocztę e-mail',
    changeFail: 'Modyfikacja stanu nie powiodła się',
    changeOne: 'Zmiana',
    changePassValidate: 'Przełącz na uwierzytelnianie hasłem',
    changePasswordFailed: 'zmiana hasła nie powiodła się',
    changePasswordSuccessful: 'Zmiana hasła powiodła się',
    changePhoneInfo: 'Przełącz na numer telefonu',
    changeStore: 'Zmień sklep',
    changeSuccess: 'Status zmodyfikowano pomyślnie',
    channelType: 'kanał zwrotny',
    characterLimitExceeded: 'Przekroczono limit znaków',
    checkConfigurationTwo: 'Chiński lub angielski %s nie jest w pełni skonfigurowany, sprawdź',
    checkCopyWriting: 'Treść w języku chińskim lub angielskim nie jest wypełniona. Sprawdź',
    checkEmpty: '%s jest pusty, sprawdź',
    checkEmptyEnglish: 'Niekompletny angielski. Sprawdź',
    checkTriggerType: 'Wystąpił warunek mechanizmu spustowego, który nie został wypełniony. Sprawdź',
    checkUpdate: 'Sprawdź aktualizacje',
    cityFilter: 'Filtr miejski',
    clickImmediateFeedback: 'Kliknij, aby teraz przekazać opinię',
    clickNumber: 'Liczba kliknięć',
    clickNumberDescription: 'Liczba powiadomień klikniętych przez Użytkowników',
    clickNumberVolume: 'Liczba kliknięć',
    clickToFeedback: 'Kliknij, aby otrzymać informację zwrotną',
    clicks: 'Kliknięcia',
    closeNum: 'zamknięcie',
    closeTask: 'Zadanie anulowane',
    code: 'Kod weryfikacyjny',
    colorPicture: 'Obraz bloku kolorów',
    comment: 'Komentarz',
    commentContent: 'Komentarze',
    commentList: 'Lista komentarzy',
    commentNumber: 'Liczba komentarzy',
    commentTime: 'Czas wystawienia komentarza',
    communication: 'w komunikacji',
    community: 'Społeczność',
    communityManagement: 'Zarządzanie społecznością',
    communityRule: 'Zasady wspólnoty',
    completePuzzle: 'Proszę o uzupełnienie układanki',
    completed: 'zakończony',
    condition: 'stan',
    configureLanguage: 'Skonfiguruj język',
    configurePicture: 'Skonfiguruj obraz',
    confirm: 'Potwierdzać',
    confirmDeletePictures: 'Potwierdź usunięcie tego zdjęcia',
    confirmRedeem: 'Potwierdź wymianę',
    confirmReviewNoPass: 'Potwierdzenie niezaliczenia przeglądu',
    confirmReviewPass: 'Potwierdź zaliczenie przeglądu',
    consultDealer: 'Skonsultuj się z lokalnym sprzedawcą',
    contact: 'Twój wniosek o usunięcie konta został odrzucony. Jeśli masz jakiekolwiek pytania, skontaktuj się z it@cfmoto.com w celu konsultacji.',
    contactMail: 'Adres e-mail',
    contactMethod: 'Kontakt',
    contactUs: 'Skontaktuj się z nami',
    content: 'Treść',
    contentType: 'Typ zawartości',
    copyFail: 'Kopiowanie nie powiodło się',
    copyLink: 'Skopiuj link',
    copySuccess: 'Skopiowano pomyślnie',
    copyWriting: 'Treść wyskakująca',
    country: 'Kraj/region',
    countryCode: 'Kod pocztowy',
    countryName: 'Kraj',
    countryNumber: 'Numer kierunkowy kraju',
    countryRegion: 'Kraj/region',
    create: 'Nowy dodatek',
    createBy: 'Twórca',
    createStore: 'Utwórz sklep',
    createTime: 'czas utworzenia',
    cs_CZ: 'Czech',
    currency: 'Waluta',
    currentConfig: {},
    currentCountryStoreTotal: 'Łączna liczba sklepów w obecnym kraju',
    currentRedemptionRatio: 'Aktualny współczynnik wymiany',
    currentTime: 'Aktualny czas',
    customPage: 'Strona niestandardowa',
    customSettings: 'Kolumny niestandardowe',
    dashcamHelp: 'Pomoc dotycząca kamery samochodowej',
    dataDeletExplain: 'Wskazówki dotyczące usuwania danych',
    dataDelete: 'Usuwanie danych',
    dataDeleteApply: 'Żądanie usunięcia danych',
    dataFormatError: 'Błąd formatu danych',
    dataPermissionScope: 'Zakres uprawnień danych',
    dataType: 'Typ danych',
    dayOne: 'dni raz',
    days: 'dzień',
    daysAgo: '%s dni temu',
    de_DE: 'Niemiecki',
    dealDate: 'Czas przetwarzania',
    dealerOperationList: 'Lista operacji dealera',
    dealerOperationQuery: 'Zapytanie o operacje dealera',
    dealerOperationRecord: 'Rejestr działań dealera',
    dealerStore: 'Sklepy dealerskie',
    dealerStoreImportTempateName: 'Szablon importu sklepu dealerskiego',
    dealerStoreQuery: 'Zapytanie dotyczące sklepów dealerskich',
    dealers: 'Importer',
    default: 'Domyślna',
    defaultMap: 'Domyślna mapa',
    delete: 'Usunąć',
    deleteAccountSYNCStep: 'Możesz wykonać następujące kroki, aby zażądać usunięcia konta CFMOTO RIDESYNC',
    deleteAccountStep: 'Możesz wykonać następujące kroki, aby zażądać usunięcia konta CFMOTO RIDE',
    deleteDataSYNCStep: 'Możesz wykonać następujące kroki, aby zażądać usunięcia swoich danych CFMOTO RIDESYNC',
    deleteDataStep: 'Możesz wykonać następujące kroki, aby zażądać usunięcia swoich danych CFMOTO RIDE',
    deleteFail: 'Nie udało się usunąć',
    deleteFinish: 'Usuwanie zakończone',
    deleteKolUserAuthentication: 'Usuń uwierzytelnianie użytkownika KOL',
    deleteStore: 'Usuń sklep',
    deleteSuccess: 'Usunięcie powiodło się',
    deleteTip: 'Czy na pewno chcesz usunąć ten post? Usuniętych informacji nie można odzyskać',
    deleteVersionWarn: 'Określa, czy usunąć ten rekord wersji',
    deleteVideo: 'Usunąć ten film?',
    detailAddress: 'Szczegółowy adres',
    details: 'Detale',
    determine: 'Pewnie',
    deviceCodeGet: 'Uzyskaj kod urządzenia:',
    deviceContent:
      'Kod urządzenia odbiornika ogrodzenia elektronicznego (zwany: kluczem) jest ciągiem 10-cyfrowych kodów. Kod urządzenia, kod QR i znak CE są wydrukowane na srebrnej naklejce samoprzylepnej z PVC. W sumie są trzy etykiety, jedna została przyklejona do nadwozia pojazdu (aby zobaczyć, należy podnieść poduszkę siedzenia); pozostałe dwa znajdują się w torbie na akcesoria pojazdu. (Zaleca się, aby użytkownik umieścił etykietę na instrukcji obsługi pojazdu lub na pilocie zdalnego sterowania)\nNaciśnij i przytrzymaj przycisk ON, aby otworzyć klucz, a następnie umieść kod QR z tyłu klucza w ramce skanującej',
    deviceNo: 'Powiązany numer urządzenia',
    deviceNumber: 'Numer urządzenia',
    deviceTitle: 'Kontrola kodu urządzenia',
    digitalKey: 'klucz cyfrowy',
    digitalKeyDesc: 'Nie ma potrzeby noszenia fizycznego klucza, obsługa odblokowania pojazdu po podłączeniu przez aplikację Bluetooth (obsługiwana przez niektóre modele)',
    directRelease: 'Bezpośrednie wydanie',
    disagree: 'nie zgadzać się',
    displayNumberDescription: 'Liczba powiadomień pokazanych na urządzeniach',
    displayNumberVolume: 'Liczba wyświetlaczy',
    displayOrder: {},
    displayPicture: {},
    donwloadTemplateDescription: {},
    download: 'Pobierz',
    downloadFailFile: 'Pobierz niepoprawny plik',
    downloadSuccessful: 'Pobierz pomyślnie',
    downloadTemplate: 'Pobierz szablon',
    downloading: 'Pobieranie...',
    ebookChoice: {},
    ebookEmpty: {},
    ebookPlaceholder: {},
    ebookSwitch: {},
    ebookTitle: {},
    edit: 'edytować',
    editAccountDeletExplain: 'Powiadomienie o usunięciu edytowanego konta',
    editActivity: 'Edytuj aktywność',
    editAppRating: 'Edytuj mechanizm oceniania',
    editBanner: 'Edytuj baner',
    editCanadaPrivacyPolicy: 'Edytuj Politykę prywatności Kanady',
    editCanadaTelematicsPolicy: 'Edytuj kanadyjską umowę telematyczną',
    editCanadaUserPolicy: 'Edytuj umowę użytkownika z Kanady',
    editDashcamHelp: 'Edytowana pomoc dotycząca kamery samochodowej',
    editDataDeletExplain: 'Edytuj powiadomienie o usunięciu danych',
    editExhibitionCategory: {},
    editExhibitionSeries: {},
    editFunctionIntro: {},
    editHelpConfiguration: 'Edytowanie konfiguracji instrukcji pomocy',
    editInformation: 'Edytuj informacje',
    editInformationCategory: 'Edytuj kategorię informacji',
    editInformationContent: 'Edytuj treść informacyjną',
    editKolUserAuthentication: 'Edytuj uwierzytelnianie użytkownika KOL',
    editModelSeries: 'Edytuj serię modeli',
    editPicture: 'Edytuj zdjęcie',
    editPushConfiguration: 'Edycja przycisku konfiguracji',
    editRemark: 'Edytuj notatki',
    editServiceIntroduce: {},
    editShowroomModel: 'Edytuj modele salonów',
    editSuccess: 'Edytowano pomyślnie',
    editTime: 'Edytuj czas',
    editUnbindingCommitment: {},
    editUser: 'Edytuj użytkownika',
    editVehicleModel: 'Edytuj model',
    editVehicleModelCategory: 'Edytuj kategorię pojazdów',
    effecting: 'Oczekiwanie na aktywację',
    effectiveTime: 'Data wejścia w życie',
    electricVehicle: 'Pojazd elektryczny',
    email: 'E-mail',
    emailAdress: 'Adres e-mail',
    emailAdressTip: 'Uwaga:  Ten adres e-mail służy do kontaktowania się z klientami za pośrednictwem poczty elektronicznej.  Upewnij się, że Twój adres e-mail jest poprawny',
    emailBindingFailed: 'Blokowanie poczty e-mail nie powiodło się',
    emailContent: 'Treść e-maila',
    emailImportTemplate: 'Szablon importu adresu e-mail',
    emailImportTemplateToDownLoad: 'Adresy e-mail można importować partiami. Kliknij, aby pobrać',
    emailList: 'Lista e-mailowa',
    emailManage: 'Zarządzanie pocztą e-mail',
    emailMass: 'Uderzenie widaomości',
    emailSearch: 'Zapytanie e-mailowe',
    emailSendTip1: 'Note: Be sure to add the note in blue font below at the end of your email. If the text of your email is not in English, please translate it into the language you are using before adding it.',
    emailSendTip2: 'If you want to unsubscribe from such emails, go to the CFMOTO RIDE App, click the [Me] > [Settings] > [Message notification] to turn off the [Receive email marketing] function.',
    emailSendTip3: '*Emails without added notes will not be reviewed and approved.',
    emailText: 'E-mail',
    emailTitle: 'Temat',
    en_US: 'język angielski',
    enableStatus: 'Stan włączony',
    enabled: 'włączać',
    endTime: 'Czas zakończenia',
    endTimeLargeStartTime: 'Czas zakończenia musi być późniejszy niż czas rozpoczęcia',
    enterAnswer: {},
    enterCategory: {},
    enterCodeToSafeAccount: 'Aby zapewnić bezpieczeństwo swojego konta, należy proszę potwierdzić informacje o koncie, które ma zostać usunięte i wprowadzić hasło lub kod weryfikacyjny w celu uwierzytelnienia swojej tożsamości.',
    enterCodeToSafeData: 'Aby zapewnić bezpieczeństwo swoich danych, należy proszę potwierdzić dane swojego konta i wprowadzić hasło lub kod weryfikacyjny w celu uwierzytelnienia swojej tożsamości.',
    enterIntroduceText: {},
    enterLink: {},
    enterPopupTitle: {},
    enterQueryConditionLookData: 'Po wprowadzeniu warunków zapytania można przeglądać dane',
    enterQuestion: {},
    enterQuestionAndAnswer: {},
    enterSureUrl: {},
    enterTypeOfLanguage: {},
    enterUnbindingCommitment: {},
    entrance: {},
    errorLatAndLon: 'Szerokość i długość geograficzna są nieprawidłowo sformatowane.',
    errorLocation: {},
    es_ES: 'hiszpański',
    estimatedTime: 'Szacowany czas',
    everySet: 'Według ustawienia',
    examineResultMessage: 'Zweryfikujemy materiały aplikacyjne tak szybko, jak to możliwe, zwróć uwagę na pasek powiadomień lub centrum wiadomości APP na czas.',
    example: 'precedens',
    exchange: 'Wykorzystaj teraz',
    exchangeDescription1:
      'Szanowny właścicielu CFMOTO, Twój pojazd został pomyślnie powiązany. Otrzymałeś roczny darmowy dostęp do inteligentnych usług.\nProszę wybrać usługi, które chcesz aktywować:\n- Wersja standardowa\n- MotoPlay Premium\nProszę przeczytać i zaakceptować warunki umowy\nZobacz „Umowę o inteligentne usługi"\n[Potwierdź]\t',
    exchangeDescription2:
      'Proszę zapoznać się z e-podręcznikiem, aby uzyskać szczegółowe informacje o pojeździe. Otrzymasz również roczny darmowy okres próbny wszystkich inteligentnych usług CFMOTO RIDE, rozpoczynający się w dniu pierwszego powiązania konta.\n[Zamknij] [Rozumiem]',
    exchangeDescription3:
      'Masz do dyspozycji XXX km dostępnego przebiegu. Wykorzystaj teraz, aby kontynuować korzystanie z inteligentnej usługi CFMOTO RIDE. Jeśli nie podejmiesz żadnych działań, dane dotyczące przebiegu zostaną zachowane przez 30 dni po rozłączeniu konta. Niewykorzystany przebieg zostanie automatycznie usunięty i nie będzie można go odzyskać po upływie tego okresu. \nCzy na pewno chcesz wykorzystać przebieg teraz?\n[Tak] [Nie]\n\n*Wykorzystane jednostki przebiegu zostaną przeniesione wraz z pojazdem do nowego właściciela.',
    exchangeDescription4: 'Masz do dyspozycji XXX km dostępnego przebiegu. Czy chcesz wykorzystać przebieg, aby nadal \nkorzystać z inteligentnej usługi CFMOTO RIDE za darmo?\n[Tak] [Nie]',
    exchangeDescription5:
      'Powiadomienie o inteligentnej usłudze\nSzanowny właścicielu motocykla CFMOTO, Pozostało XXX dni darmowego okresu próbnego inteligentnej usługi CFMOTO. Po aktywacji usługi, zostanie ona uruchomiona w ciągu 24 godzin – prosimy o sprawdzenie powiadomień.\n[Potwierdź]',
    exchangeDescription6: 'Ciesz się lepszą trasą z MotoPlay, oferującym usługi mirroringu ekranu i nawigacji zasilane przez Google Maps',
    exchangeRecords: 'Rejestr realizacji',
    exchangeServiceTime: 'Masz dostępny przebieg, który można wykorzystać na godziny usług',
    exchangeSuccess: 'Pomyślnie zrealizowano',
    exhibition: {},
    exhibitionCategory: {},
    exhibitionCategoryList: {},
    exhibitionCategorySearch: {},
    exhibitionSeries: {},
    exhibitionSeriesList: {},
    exhibitionSeriesSearch: {},
    exportContent: 'Eksportowana treść',
    exportExcel: 'Eksport do Excela',
    exportLengthExceedOfMonth: 'Długość wywozu nie może przekraczać %s miesięcy',
    externalLink: 'Link zewnętrzny',
    failed: 'Przegrany',
    failedToPreview: 'Przegląd nie powiódł się',
    feedBackResut: 'Wyniki sprzężenia zwrotnego',
    feedBackTime: 'Czas na opinię',
    feedBackVechle: 'Pojazd',
    feedbackAppQuestion: 'Proszę opisać szczegółowo czas wystąpienia, wersję APP, model telefonu komórkowego, ścieżkę działania i opis problemu, aby pomóc szybko zlokalizować i rozwiązać problem!',
    feedbackDetails: 'Szczegóły opinii',
    feedbackGuideDesc: 'Aby uzyskać więcej informacji, skontaktuj się z nami za pośrednictwem poniższego kanału opinii',
    feedbackLabelFileList: 'Prosimy o przesłanie zdjęcia',
    feedbackMapQuestion: {},
    feedbackMessageSubmitError: 'Informacja zwrotna nie powiodła się',
    feedbackOtherQuestion: 'Proszę opisać kiedy to się stało, jak to się stało i jaki jest problem',
    feedbackReceived: 'Otrzymane opinie',
    feedbackRecord: 'Zapis informacji zwrotnej',
    feedbackRulesFileListMaxSize: 'Przesłany plik jest zbyt duży',
    feedbackRulesFileListOverType: 'Nieobsługiwany format',
    feedbackSubmitTip: 'Jeśli masz jakieś pytania lub uwagi, możesz również skontaktować się z Centrum Obsługi Klienta CFMOTO Meksyk bezpośrednio za pośrednictwem WhatsApp (+52 18115286003) lub e-maila (servicioalclient@cfmoto.com.mx)',
    feedbackSuggest: 'Zapraszamy do składania cennych sugestii, poważnie rozważymy Twoje pomysły',
    feedbackSupplement: 'Dodaj opis problemu',
    feedbackText: 'Opinie',
    feedbackType: 'Rodzaj informacji zwrotnej (jeden wybór)',
    feedbackVehicleQuestion: 'Proszę opisać kiedy to się stało, jak to się stało i jaki jest problem',
    female: 'Kobieta',
    fileCountExceed: 'Liczba plików przekracza limit',
    fileSizeExceed: 'Rozmiar pliku przekracza limit',
    fileUploadingPleaceWait: 'Przesyłanie pliku. Proszę czekać',
    finalOperator: {},
    firstBindDate: 'Czas Pierwszego Połączenia Pojazdu',
    firstMenu: 'Menu pierwszego poziomu',
    forcedUpgrade: 'Wymuszona aktualizacja',
    forgetPassword: 'Zapomnij hasło',
    fourCarOfNumber: 'Liczba użytkowników pojazdów czterokołowych',
    fourWheel: 'Motocykle czterokołowe',
    fourWheelConfig: {},
    fourWheeler: 'Czterokołowiec',
    fourWheelerMostClicks: 'Modele pojazdów czterokołowych z największą liczbą kliknięć',
    fourWheelowner: {},
    fr_FR: 'Francuski',
    frankfurt: 'Frankfurt',
    freeLastDayBasedata: 'Darmowy Okres Wersji Standard',
    freeLastDayMotoplay: 'Darmowy Okres MotoPlay',
    friday: 'Piątek',
    fuctionIntro: {},
    fullscreen: 'Pełny ekran',
    funServiceIntro: {},
    function: 'Funkcjonować',
    functionConfiguration: {},
    functionConfigureTip: 'Funkcja ma zastosowanie wyłącznie do pojazdów skonfigurowanych pod nazwą importera lub użytkowników w kraju/regionie.',
    functionDescription: {},
    functionDetail: {},
    functionIntroduce: 'Опис функције',
    functionSetting: {},
    functionalOverview: 'Przegląd funkcji',
    galleryEntrance: 'Wejście do galerii',
    galleryEntranceUploadRules: 'Wymagania dotyczące formatu: jpg/jpeg/png, zalecany format 4:3, rozmiar nie większy niż 5MB',
    gender: 'Seks',
    generalAgreementText: 'Tekst umowy ogólnej',
    generalAlarm: 'Alarm ogólny',
    geofence: 'Ogrodzenie elektroniczne',
    getCarPosition: 'Uzyskaj lokalizację pojazdu na czas',
    getCode: 'Wysłać',
    getExchangeRecordsError: 'Nie udało się pobrać rejestru realizacji',
    goCustomPage: 'Przejdź do strony niestandardowej',
    goOffline: 'Offline',
    goOnline: 'Online',
    goUrlLink: 'Przejdź do łącza URL',
    groupTrail: {},
    groupTrailConfig: {},
    guest: 'Nie ma samochodu',
    haveTwo: 'Oba',
    havedWrite: 'Wypełniony',
    havedWriteAll: 'została wypełniona',
    havedWriteAllOrEmpty: 'jest wypełnione lub puste',
    helpAndFeedback: 'Pomoc i opinie',
    helpCenter: 'Centrum pomocy',
    helpConfiguration: 'Pomoc wyjaśnia konfigurację',
    helpMessageHistoryDelete: 'Usunąć wszystkie rekordy wyszukiwania?',
    helpful: {},
    hint: 'Wskazówka',
    historyDelete: 'Usunąć wszystkie rekordy wyszukiwania?',
    home: 'Strona główna',
    homePage: 'Osobista strona główna',
    hour: 'Godzina',
    hoursAgo: '%s godzin temu',
    iWantEnableStoreUserQuery: 'Chcę aktywować wyszukiwanie użytkowników sklepu',
    iWantToPostStatistics: 'Chcę opublikować statystyki',
    identification: 'Identyfikacja',
    identificationText: 'Identyfikacja',
    imageSizeExceed: 'Proszę przesłać zdjęcie o szerokości i wysokości %s',
    imageUploadFailed: 'Przesyłanie zdjęć nie powiodło się',
    immediateRelease: 'Natychmiastowe udostępnienie',
    immediateSend: 'Wyślij teraz',
    imporFailedOfTableHeader: 'Import nie powiódł się. Nagłówek pliku nie został dopasowany',
    import: 'import',
    importDetails: 'Szczegóły zapytania',
    importExcel: 'Importuj EXCEL',
    importFail: 'Importowanie nie powiodło się',
    importStatus: 'Status importu',
    importSuccessful: 'Importowanie powiodło się',
    importTemplate: 'Importuj szablon do pobrania',
    importer: 'importer',
    importerAccountOperationRecord: 'Działania konta importera i rejestr logowań',
    importerAvatar: 'Awatar importera',
    importerDisplayName: 'Wyświetlana nazwa importera',
    importerEnquiry: 'Zapytanie importera',
    importerManagement: 'Zarządzanie importerami',
    importerOperationRecords: 'Rejestr operacji importera',
    importing: 'Importowanie...',
    inProcess: 'środki zaradcze',
    inProgress: 'w trakcie',
    individualCenter: 'Centrum indywidualne',
    informationCategory: 'Kategoria informacyjna',
    informationCategoryList: 'Lista kategorii informacji',
    informationCategoryQuery: 'Zapytanie o kategorię informacji',
    informationContent: 'Treść informacji',
    informationContentList: 'Lista treści informacyjnych',
    informationCotnentQuery: 'Zapytanie o treść informacji',
    informationCover: 'Okładka informacyjna',
    informationDetails: 'Information Detaljer',
    informationImage: 'okładka',
    informationManagement: 'Zarządzanie informacjami',
    informationTitle: 'Tytuł informacyjny',
    informer: 'Informator',
    informerId: 'Identyfikator informatora',
    initialPassword: 'Początkowe hasło',
    inputAgreementContent: 'Prosimy o podanie treści umowy',
    inputCannotExceed20000: 'Maksymalnie 20000 znaków',
    inputErrorEmoji: 'Prosimy o niewprowadzanie emotikonów',
    installDeviceYouCan: 'Zainstalowanie tego urządzenia umożliwia',
    installVehicleModelAdd: 'Dodaj Opis modernizowanego modelu pojazdu',
    installVehicleModelDescription: 'Opis modernizowanego modelu',
    installVehicleModelEdit: 'Edytuj Opis modernizowanego modelu pojazdu',
    instrumentLastedVersion: 'Wyświetlacz TFT nie wymaga aktualizacji',
    instrumentupgrade: 'Aktualizacja wyświetlacza TFT',
    inteligentServiceReminder: 'Przypomnienie o inteligentnej usłudze',
    intelligentInternetServiceIntroduction: 'Wprowadzenie do usługi',
    intelligentServiceAgreement: 'Umowa o inteligentnej usłudze',
    intelligentServices: 'Usługi inteligentne (szczegóły pojazdu, dane z jazdy, aktualizacje OTA)',
    introText: {},
    introduction: 'Wstęp',
    invalidVercode: 'nieprawidłowy kod weryfikacyjny',
    invoicePreview: 'Podgląd faktury',
    invoicing: 'Fakturowanie',
    invoicingFailed: 'Fakturowanie nie powiodło się',
    invoicingSucceeded: 'Fakturowanie powiodło się',
    iovNotice1: 'Powyższe funkcje są oparte na urządzeniu sieciowym pojazdu (T-Box), skonsultuj się z lokalnym dealerem, aby kupić i zainstalować',
    iovNotice2: 'Powyższe funkcje różnią się w zależności od konfiguracji każdego modelu i regionu, w którym się znajduje. Aby uzyskać szczegółowe informacje, skonsultuj się z lokalnym sprzedawcą.',
    iovNotice3: 'Prosimy o wcześniejsze zapisanie i zapisanie numeru urządzenia, który jest wymagany przy wiązaniu urządzenia. Po zakończeniu wiązania i instalacji możesz korzystać z większej liczby funkcji',
    isHelpful: 'Czy to pomaga?',
    isStop: {},
    isSupportedChildOwnerOffMapDown: {},
    isSupportedNoOwnerOffMapDown: {},
    isSupportedOffMapDown: {},
    it_IT: 'Włoski',
    iterativeVehicleFunctions: 'Główne części pojazdu można zdalnie aktualizować online, aby stale powtarzać funkcje pojazdu',
    jumpSettings: 'Ustawienia skoku',
    jumpTarget: {},
    jumpToWeb: {},
    jumpUrl: {},
    justNow: 'Teraz',
    keySharing: 'Cyfrowy klucz i udostępnianie klucza',
    kolUser: 'Użytkownik KOL',
    kolUserList: 'Lista użytkowników KOL',
    kolUserManagement: 'Zarządzanie użytkownikami KOL',
    kolUserQuery: 'Zapytanie o użytkowników KOL',
    language: 'Język',
    language1: 'Język związany',
    languages: 'język',
    lastLoginTime: 'Czas ostatniego logowania',
    lastModifiedBy: 'Ostatnio zmodyfikowany przez',
    lastUpdateTime: 'Czas ostatniej aktualizacji',
    latitude: 'Szerokość geograficzna',
    launchActivity: 'Uruchom aktywność',
    likeNumber: 'Liczba polubień',
    linkAddress: {},
    linkUrlDescription: {},
    linkedOrder: 'Powiązane zamówienie',
    listDisplayImages: 'Wyświetlanie listy',
    listOfImporters: 'Lista importerów',
    listOfQuestion: {},
    listShowStoreCoverPic: 'Pokaż obraz okładki sklepu',
    loadMore: 'Załaduj więcej',
    loadSuccess: 'Ładowanie zakończone',
    loading: 'Ładowanie',
    locationFail: {},
    log: 'Dziennik',
    login: 'Zaloguj sie',
    loginCountry: 'Kraj/region logowania',
    loginSuccessfully: 'Zaloguj się pomyślnie',
    logout: 'Wyloguj',
    longitude: 'Długość geograficzna',
    loosing: 'Gegevens vernieuwen...',
    lowCompatibleVersion: 'Minimalna kompatybilna wersja',
    mail: 'E-mail',
    male: 'Mężczyzna',
    manualReviewStatus: 'Status ręcznego przeglądu',
    mapManage: {},
    marketDataOfdealerStores: 'Dane rynkowe sklepów dealerskich',
    masteringCyclingData: 'Mistrzowskie dane dotyczące jazdy',
    maximum: 'Maks.',
    maximumBannerCountTip: 'Do %s banerów może być online w tym samym czasie.  Najpierw usuń przynajmniej jeden z nich.',
    maximumMileage: 'Maksymalny możliwy do wymiany przebieg',
    maximumValue: 'Maksimum',
    menuFunctionName: 'Nazwa funkcji menu',
    menuIcon: 'Ikona menu',
    messagePush: 'Naciśnięcie wiadomości',
    messagePushDeleteAsk: 'Czy na pewno chcesz usunąć to naciśnięcie?',
    messagePushDownloadTemplate: 'Najpierw pobierz szablon i prześlij plik po wypełnieniu pliku szablonu. Rozmiar pliku jest ograniczony do 2M. Jeśli przesyłanie nie powiedzie się, prosimy o odpowiednie zmniejszenie zawartości',
    messageWithdrawAsk: 'Czy chcesz wycofać to naciśnięcie?',
    middle: 'środek',
    min: 'Min',
    minAgo: '%s minut temu',
    minimum: 'Min.',
    minimumValue: 'Minimum',
    modelDetail: 'Szczegóły modelu',
    modifyFail: 'Modyfikacja nie powiodła się',
    modifyPassword: 'Zmień hasło',
    modifySuccess: 'Modyfikacja powiodła się',
    monday: 'Poniedziałek',
    more4pic1video: 'Maksymalnie 4 zdjęcia / 1 film',
    moreDetailsConsultDealerStore: 'Aby uzyskać więcej informacji, skontaktuj się ze swoim dealerem',
    morning: 'Rano',
    motoPlay: 'MotoPlay (usługa mirroringu ekranu i nawigacji oparta na Google Maps)',
    motoPlayAgreement: 'Status umowy MotoPlay',
    motoplatNavigationScreen: 'MotoPlay — ekran z nawigacją i mirroringiem',
    motoplayServicePay: 'Płatność za MotoPlay',
    motoplayServiceResetTimeRule: 'Czas resetowania MotoPlay nie może być późniejszy od czasu bieżącego',
    motorcycle: 'dwukołowiec',
    moveDown: 'Przesuń w dół',
    moveLongPressMap: {},
    moveMapSelectPoint: {},
    moveTo: 'Przesuń do',
    moveToBottom: 'Przesuń na dół',
    moveToTop: 'Przesuń na górę',
    moveToTopStatus: 'Przesuń na górę',
    moveTop: 'Górne ustawienia',
    moveUp: 'Przesuń w górę',
    multimedia: 'Multimedia',
    mustInteger: {},
    mute1Day: 'Wyciszenie na 1 dzień',
    mute2Days: 'Wyciszenie na 2 dni',
    mute30Days: 'Wyciszenie na 30 dni',
    mute3Days: 'Wyciszenie na 3 dni',
    mute7Days: 'Wyciszenie na 7 dni',
    muting: 'Wyciszanie',
    nameOfImporter: 'Nazwa importera',
    navigation: 'Nawigacja po mapie',
    nearLoginTime: 'Czas ostatniego logowania',
    needPopup: 'Potrzebujesz wyskakującego okienka',
    negativeNum: 'Zła recenzja',
    networkException: 'Wyjątek sieci',
    newAddFail: 'Dodawanie nie powiodło się',
    newAddSuccess: 'dodano pomyślnie',
    newBanner: 'Nowy baner',
    newCancellationAgreement: 'Nowa umowa anulowania',
    newEmail: 'Nowy email',
    newEmailEqualsValidate: 'Nowy adres e-mail nie może być taki sam jak pierwotny adres e-mail',
    newFunctionIntro: {},
    newMenuFunction: 'Nowa funkcja menu',
    newModelSeries: 'Nowa seria modeli',
    newPassword: 'Nowe hasło',
    newPasswordNotEqual: 'Nowe hasło wprowadzone dwukrotnie jest niespójne, wprowadź ponownie',
    newQuestionType: {},
    newStoreNumber: 'Liczba nowych sklepów',
    newTopic: 'Nowy temat',
    newUnbindingCommitment: {},
    nextStep: 'Następny',
    nickName: 'Przezwisko',
    no: 'Nie',
    noContent: 'Brak powiązanych treści',
    noContent2: 'Zaproponuj zmianę słów kluczowych lub',
    noData: 'Brak danych',
    noExchangeRecord: 'Brak zapisów wymiany przebiegu',
    noFeedbackRecord: 'W chwili obecnej nie ma zapisów zwrotnych.',
    noJump: 'Żadnego skoku',
    noLog: 'Brak dziennika',
    noMores: 'Nie ma więcej',
    noNeedPopup: 'Nie są wymagane żadne wyskakujące okienka',
    noOkToFeedback: 'Nierozwiązany, chcę wyrazić opinię',
    noOwnerScore: 'Oceny niebędące właścicielami',
    noPass: 'Odrzuć',
    noSendPeople: 'Brak nadawcy',
    noSortingPermission: 'Brak uprawnień do sortowania',
    noSupportMapDown: {},
    noThisPermission: 'Brak pozwolenia na tę operację',
    noUserSelected: 'Nie wybrano użytkownika, nie można przesłać',
    nofiledSeviceContent: {},
    nonOwner: 'Osoba niebędąca właścicielem',
    nonVehicleOwnerCharged: {},
    none: 'Żaden',
    normal: 'Normalne',
    notAllowImageAndVideo: 'Podczas wybierania zdjęć nie można wybrać filmu wideo',
    notAllowed: 'Niedozwolone',
    notBeLessOrEqual: 'Nie może być mniejsza lub równa',
    notDeleted: 'Nie wylogowane',
    notDistributedYet: 'Ej utfärdad än',
    notEnabled: 'Nie włączone',
    notHelpful: {},
    notLessThan: 'Nie może być mniejszy niż',
    notRecommended: 'Niezalecane',
    notReleasedYet: 'Jeszcze nie wydany',
    notStarted: {},
    'notSupportT-Box': 'Przepraszamy, Twój pojazd nie obsługuje modułu T-Box',
    notTop: 'Nie do samej góry',
    notice: 'Zauważyć',
    noticeText1: 'Dear CFMOTO users,',
    noticeText2:
      'Hello! We sincerely thank you for your continuous support and trust in CFMOTO. We are committed to enhancing service quality and implementing innovative improvements, and we have made business adjustments due to this commitment. As of 08/10/2024, we will discontinue the CFMOTO RIDE App (the "App") in the United States. In its place, we have launched the brand-new CFMOTO RIDESYNC App. We hope you continue to enjoy our services through this new app.',
    noticeText3: 'Important notes:',
    noticeText4: '1. From today on, this app will only be available for bound CFMOTO vehicles in the United States and no longer support binding new vehicles. If you need to bind a new vehicle, please download and use the CFMOTO RIDESYNC App.',
    noticeText5:
      '2. We strongly recommend that you download and use the CFMOTO RIDESYNC App before 08/10/2024 so that you can continue enjoying our services seamlessly. We provide you with a convenient data migration service. You can choose to migrate all data retained in this App to the CFMOTO RIDESYNC App to preserve your personal information, vehicle information and past service records. We will ensure your data security and privacy during the migration process. If you want to use the CFMOTO RIDESYNC App without migrating data, you can re-register with the CFMOTO RIDESYNC App to use the new services. Click on the button below to learn how to download and use the CFMOTO RIDESYNC App.',
    noticeText6:
      '3. Please note that after 08/10/2024, you will no longer be able to use the relevant services of the App in the United States. Meanwhile, we will delete all personal data generated during your use of the App according to the relevant laws and regulations.',
    noticeText7:
      'We are fully aware that this change may cause temporary inconvenience to you, but we believe that with this service upgrade, you will have a richer and more satisfying user experience. If you encounter any issues or have questions during this process, we will always be here to help. Thank you for your understanding and cooperation, and we look forward to serving you in the CFMOTO RIDESYNC App.',
    noticeText8: 'Wish you a happy life!',
    notzero: 'Wszystkie numery wersji nie mogą mieć wartości 0',
    obtainVerificationCode: 'Uzyskanie kodu weryfikacyjnego',
    officiaAndKolList: 'Lista Oficjalne/KOL',
    officialAccount: 'Oficjalne konto',
    officialAccountAuth: 'Uwierzytelnienie oficjalnego konta',
    officialIrKOLSearch: 'Wyszukiwanie urzędników/KOL',
    officialKolAuth: 'Oficjalne/KOL uwierzytelnienie',
    offline: 'Offline',
    offlineAlready: 'Offline',
    offlineTime: 'Czas offline',
    offlineTimeMustBeGreaterThan: 'Czas offline musi być dłuższy niż',
    ok: 'OK',
    oldPassword: 'Stare hasło',
    onLineAlready: {},
    oneMonths: 'Jeden miesiąc',
    oneYear: 'Jeden rok',
    online: 'Online',
    onlyFourWheel: 'Tylko czterokołowe',
    onlyTwoWheel: 'Tylko dwukołowe',
    openEveryCount: {},
    openEveryDay: {},
    openProductType: {},
    operationRecord: 'Rejestr operacji',
    operationTime: 'Czas działania',
    operations: 'Operacje',
    operator: 'Operator',
    operattor: 'Operator',
    opreate: {},
    opreateFunSet: {},
    opreateFunSetAdvert: {},
    opreateFunSetAdvertAdd: {},
    opreateFunSetAdvertEdit: {},
    opreateFunSetAdvertView: {},
    optionalUpgrade: 'Opcjonalna aktualizacja',
    orderFeedBackNum: 'Liczba zgłoszeń dotyczących zamówienia',
    orderList: {},
    orderMange: {},
    orderNum: {},
    orderQuestion: 'Opisz czas wystąpienia i szczegóły problemu oraz prześlij jeden lub więcej zrzutów ekranu przedstawiających ten problem. W przypadku problemów z płatnością prześlij również potwierdzenie obciążenia.',
    originalEmail: 'Oryginalny email',
    otaUpgradeVehicle: 'Pojazd do aktualizacji OTA',
    otaUpgradeVehicleDesc: 'Główne komponenty pojazdu można modernizować zdalnie, aby stale monitorować wydajność pojazdu.',
    other: 'Inne',
    over: 'nad',
    owner: 'Weź samochód',
    ownerIdHomepageImage: 'Główna strona dowodu osobistego, prawa jazdy lub paszportu, zawierająca informacje tożsamościowe.',
    parameterConfiguration: 'Konfiguracja parametrów',
    partialImportFailed: 'Częściowe importowanie nie powiodło się',
    pass: 'Zatwierdź',
    passValidateDeleteAccount: 'Pomyślna weryfikacja tożsamości!  Kliknij przycisk Prześlij wniosek na dole, aby złożyć wniosek o usunięcie konta',
    password: 'Hasło',
    passwordRuleText: '8-20 znaków, musi zawierać wielkie i małe litery angielskie, cyfry, znaki specjalne',
    passwordRules: 'Zasady hasła',
    paySetting: {},
    payStrategy: {},
    paymentLastDayBasedata: 'Płatny Okres Wersji Standard',
    paymentLastDayMotoplay: 'Płatny Okres MotoPlay',
    peleaseEnterProvince: 'Wprowadź województwo/stan',
    pendSend: 'Aż do',
    pending: 'W trakcie.',
    pendingSubmit: 'Oczekujące na przesłanie',
    permanentMuting: 'Wycisz na stałe',
    phoneModel: 'Model',
    phoneNum: 'numer telefonu',
    phoneNumber: 'Numer telefonu',
    phoneOrEmail: 'Numer telefonu/E-mail',
    phoneOrEmailImportTemplate: 'Szablon importu numeru telefonu komórkowego/adresu e-mail',
    phoneOrEmailNotRegistered: 'Ten numer telefonu komórkowego lub adres e-mail nie jest zarejestrowany.',
    phoneOrEmailOrUserId: 'Numer telefonu komórkowego/adres e-mail/numer identyfikacyjny użytkownika',
    picture: 'Zdjęcie',
    pl_PL: 'Polski',
    pleaseAddImage: 'Proszę dodać pliki obrazów',
    pleaseAddVideoFile: 'Proszę dodać pliki wideo',
    pleaseEnter: 'Proszę wejść',
    pleaseEnterAccountInfo: 'Proszę wprowadzić informacje o koncie',
    pleaseEnterAmount: {},
    pleaseEnterCity: 'Wprowadź miasto',
    pleaseEnterEmail: 'Podaj swój adres e-mail',
    pleaseEnterEmailAdress: 'Proszę podać adres e-mail',
    pleaseEnterIntro: 'Proszę wprowadzić wprowadzenie',
    pleaseEnterLatAndLong: 'Wprowadź szerokość i długość geograficzną',
    pleaseEnterNewPassword: 'Wprowadź nowe hasło',
    pleaseEnterPassword: 'Proszę wprowadzić hasło',
    pleaseEnterPhone: 'Wprowadź swój numer telefonu',
    pleaseEnterQuestionDescription: 'Proszę wprowadzić opis problemu',
    pleaseEnterRealname: 'Wpisz swoje prawdziwe imię',
    pleaseEnterRemark: 'Proszę wpisać uwagi',
    pleaseEnterServePhone: 'Wprowadź numer telefonu serwisowego',
    pleaseEnterStoreAddressDetail: 'Wprowadź szczegółowy adres',
    pleaseEnterStoreIntroduce: 'Wprowadź opis sklepu',
    pleaseEnterStoreName: 'Wprowadź nazwę sklepu',
    pleaseEnterStoreRemarkName: 'Wprowadź nazwę uwagi sklepu',
    pleaseEnterTitle: 'Proszę wpisać tytuł',
    pleaseEnterUsername: 'Proszę podać nazwę użytkownika',
    pleaseEnterVercode: 'Proszę wprowadzić kod weryfikacyjny',
    pleaseEnterVersion: 'Proszę wprowadzić numer wersji',
    pleaseEnterVersionIntroduction: 'Proszę wprowadzić wprowadzenie do wersji',
    pleaseEnterVideoDetail: 'Wprowadź szczegóły filmu',
    pleaseEnterVin: 'Podaj VIN',
    pleaseInputWord: 'Wprowadź słowo kluczowe',
    pleaseLoginFirst: 'Proszę najpierw się zalogować',
    pleaseRepeatNewPassword: 'Proszę powtórzyć nowe hasło',
    pleaseSelect: 'proszę wybrać',
    pleaseSelectAuthAccount: 'Wybierz konto do uwierzytelnienia',
    pleaseSelectBusinessHours: 'Wybierz godziny otwarcia',
    pleaseSelectCity: 'Proszę wybierz miasto',
    pleaseSelectCountry: 'Proszę wybrać kraj',
    pleaseSelectCurrency: {},
    pleaseSelectMatchingMultimediaContent: 'Wybierz pasującą zawartość multimedialną',
    pleaseSelectPayChannel: {},
    pleaseSelectProblemWhere: 'Wybierz scenariusz, w którym występuje problem',
    pleaseSelectProducType: {},
    pleaseSelectProvince: 'Wybierz województwo/państwo',
    pleaseSelectQueType: 'Wybierz rodzaj pytania',
    pleaseSelectReportReason: 'Wybierz powód zgłoszenia',
    pleaseSelectService: 'Najpierw wybierz usługę',
    pleaseSelectStatus: 'Wybierz status',
    pleaseSelectStoreType: 'Wybierz typ sklepu',
    pleaseSelectTimedSendTime: 'Proszę wybrać czas wysyłki',
    pleaseSelectUserTheList: 'Wybierz użytkownika z listy',
    pleaseSelectVehicle: 'Proszę wybrać pojazd',
    pleaseSelectVehicleConfig: {},
    pleaseSelectlinkedOrder: 'Proszę wybrać powiązane zamówienie.',
    pleaseSelectupgradeType: 'Wybierz metodę aktualizacji',
    pleaseSureType2: 'Upewnij się, że wszystko w',
    pleaseUpload: 'Proszę przesłać',
    pleaseUploadPicVideo: 'Prosimy o przesłanie zdjęć/filmów',
    pleaseUserTimeFill: 'Proszę wypełnić zgodnie z czasem użytkownika końcowego',
    popUpFrequencyType: 'Wyskakujący formularz okna',
    popUpFrequencyValue: 'Częstotliwość wyskakujących okienek',
    popUpFrequencyValueValid: 'Proszę wybrać dni częstotliwości',
    popUpReminder: 'Czy wyświetlić przypomnienie',
    popupArea: 'wyskakujący zakres użytkowników',
    popupCreate: {},
    popupDayOne: 'Raz na ustaloną liczbę dni',
    popupEdit: {},
    popupFrequency: {},
    popupManagement: {},
    popupOne: {},
    popupPosition: {},
    popupStatus: {},
    popupTarget: {},
    popupTime: {},
    popupTitle: {},
    positiveNum: 'Dobre recenzje',
    postComment: 'Komentarze do posta',
    postContent: 'Treść posta',
    postId: 'ID posta',
    postList: 'Lista postów',
    postManagement: 'Zarządzanie postami',
    postSearch: 'Wyszukiwanie postów',
    posts: 'Posty',
    precautionText1:
      'Hello! As you have learned that we will discontinue the CFMOTO RIDE App (hereinafter referred to as "the App") in the United States from 08/10/2024, to assist you with this change, please take note of the following important matters:',
    precautionText2: '1. From today on, you will not be able to bind a new vehicle through the APP to enjoy relevant vehicle services.',
    precautionText3: '2. To ensure a smooth transition to the new service, we have provided an entry at the top of the vehicle page in this App. You can learn how to download and use the CFMOTO RIDESYNC App at any time through that entry.',
    precautionText4:
      '3. Please note that once the service ceases to take effect, you will no longer be able to enjoy any services of the App in the United States. At the same time, we will delete all personal data generated during your use of the App in accordance with relevant laws and regulations. This means that we will not be able to respond to any of your requests for data after the service is discontinued.',
    precautionText5:
      'We understand that this change may cause inconvenience to you, but we are committed to continuously protecting your data security and privacy. We encourage you to take early action to download and start using the CFMOTO RIDESYNC App in a timely manner so that you can continue to enjoy the quality service provided by CFMOTO. If you have any questions or need assistance in this process, please do not hesitate to contact us. We look forward to serving you in the CFMOTO RIDESYNC App.',
    privacyContent: 'Szczegóły treści polityki prywatności',
    privacyPolicy: 'Polityka prywatności',
    privacyPopupAgree: 'Uzyskaj ponownie zgodę użytkownika na politykę prywatności poprzez wyskakujące okienko',
    privacyVersion: 'Wersja Polityki Prywatności',
    privacyVersionList: 'Lista wersji Polityki prywatności',
    problemaDes: 'Opis problemu',
    processMethod: 'Metody przetwarzania',
    processReason: 'Powód przetwarzania',
    processReasonDetails: 'Szczegóły dotyczące przyczyny przetwarzania',
    processRecord: 'Rejestr przetwarzania',
    processReport: 'Raporty z przetwarzania',
    processSolution: 'Przetwarzanie rozwiązania',
    processUser: 'Przetwórz użytkownika',
    processed: 'Przetworzone',
    productDetails: {},
    productTime: 'czas produkcji',
    prohibitDecimalsAndNegative: {},
    pt_PT: 'portugalski',
    publishInformation: 'Publikuj informacje',
    publishPosts: 'Opublikuj posty',
    pullBefore: 'Pociągnij w dół, aby odświeżyć.',
    pulling: 'Zwolnij odświeżenie teraz',
    purchaseAndInstall: 'Kup i zainstaluj',
    pushConfiguration: 'Naciśnij konfigurację',
    pushContent: 'Przesyłaj treści',
    pushList: 'Naciśnij listę',
    pushMode: 'Naciśnijn tryb',
    pushNow: 'Naciśnij teraz',
    pushQuery: 'Naciśnij zapytanie',
    pushRecord: 'Naciśnij nagrywanie',
    pushScope: 'Naciśnij zakres',
    pushTime: 'Naciśnij czas',
    pushTimeDifferenceAsk: 'Wybrany czas wysłania może spowodować, że niektórzy użytkownicy nie będą mogli odebrać tego pushu ze względu na różnice czasowe. Czy na pewno chcesz zapisać?',
    pushTitle: 'Naciśnij tytuł',
    pushed: 'Wypchnięty',
    pushing: 'Naciskanie',
    quantity: 'Ilość',
    query: 'Szukaj',
    question: {},
    questionInquiry: {},
    questionType: 'Typ pytania',
    questionTypeList: {},
    questionTypeTemplate: {},
    quickRelease: 'Szybkie wydanie',
    ranking: 'Ranking',
    ratingWarn1: 'W przypadku właścicieli pojazdów kontrola usług inteligentnych odpowiadająca krajowi/regionowi w tle zarządzania nie została włączona lub usługa inteligentnych usług nie wygasła po włączeniu. Pojazd jest online i ma',
    ratingWarn2: 'lub więcej kompletnych zapisów jazdy (zdarzeniem jest raportowany początek i koniec każdej jazdy). Gdy użytkownik opuści My Cycling i powróci na stronę główną, pojawi się wyskakujące okienko.',
    reUpgrade: 'Ponowić',
    readAgree: 'Przeczytać i zaakceptować',
    readAndAgree: 'Przeczytaj i zaakceptuj',
    readAndAgreeTo: 'Przeczytałem i akceptuję',
    readDeleteStep: 'zapoznaj się z rodzajami danych, które będziemy usuwać lub przechowywać, oraz wszelkimi dodatkowymi okresami przechowywania',
    realname: 'Prawdziwe imię',
    reasonForReport: 'Powód',
    receiveCarReminderMessage: 'Otrzymuj powiadomienia o wiadomościach o pojeździe',
    rechargeAmount: {},
    rechargeChannel: {},
    rechargeStatus: {},
    rechargeTime: {},
    recharged: {},
    recipients: 'Odbiorca',
    recipientsNum: 'Zakres odbiorcy',
    recommended: 'Zalecane',
    recommendedStatus: 'Zalecany status',
    redeemableServiceHours: 'Godziny usług możliwe do wymiany',
    redemptionMileage: 'Dostępny przebieg do wykorzystania',
    redemptionRatio: 'Współczynnik wymiany',
    redemptionTime: 'Czas wymiany',
    redirectUrl: {},
    refreshInterval: 'Częstotliwość odświeżania',
    refreshSend: 'wysłać ponownie',
    refundFailed: {},
    refunded: {},
    refunding: {},
    refused: 'Odrzucono',
    registerDate: 'Czas rejestracji',
    rejected: 'Odrzucono',
    releaseContent: 'Treść wydania',
    releaseMethod: 'Metoda wydania',
    releaseMute: 'Wyłącz wyciszenie',
    releaseTime: 'Czas wydania ：',
    released: 'Wydany',
    releasedBy: 'Wydane przez',
    remainServiceHavExpired: 'Czas pozostający do wygaśnięcia inteligentnej usługi',
    remainingAvailableMileage: 'Pozostały dostępny przebieg',
    remark: 'Uwagi',
    rememberPassword: 'Zapamiętaj hasło',
    reminder: 'Przypomnienie',
    remove: 'Usuń',
    removeOnlinUpgrade: 'Pojazd do zdalnej aktualizacji online',
    repeatNewPassword: 'Powtórz nowe hasło',
    replaceTBOX: 'Wymień TBOX',
    replied: 'Odpowiedzieli',
    reply: 'Odpowiedzi',
    report: 'Raport',
    reportList: 'Lista raportów',
    reportManagement: 'Zarządzanie raportami',
    reportReason: 'Powód zgłoszenia',
    reportReasonDetails: 'Szczegóły dotyczące przyczyny zgłoszenia',
    reportReasonPlaceholder: 'Napisz, co chcesz zgłosić, 0-1500 słów',
    reportSearch: 'Wyszukiwanie raportów',
    reportSuccessful: 'Zgłoszenie powiodło się, zajmiemy się nim tak szybko, jak to możliwe',
    reportTime: 'Czas raportowania',
    reportType: 'Rodzaj raportu',
    reportedContent: 'Zgłoszona treść',
    reportedUser: 'Zgłoszony użytkownik',
    reportedUserId: 'Identyfikator zgłoszonego użytkownika',
    requestTimedOut: 'Upłynął limit czasu żądania',
    resend: 'Wyślij ponownie',
    resendTo: 'Wyślij ponownie do',
    reset: 'Zresetuj',
    resetItem: 'Zresetuj element',
    resetTime: 'Czas resetowania usług inteligentnych',
    resetWarn: 'Po resetowaniu darmowy okres usług inteligentnych tego pojazdu zostanie przeliczony i wejdzie w życie na podstawie bieżącego czasu (czasu przeglądarki). Potwierdzić resetowanie?',
    return: 'Wróć',
    review: 'Przegląd',
    reviewApproved: 'Przegląd zaliczony',
    richText: {},
    ro_RO: 'rumuński',
    roleDescription: 'Opis roli',
    roleName: 'Nazwa roli',
    rolePermission: 'Uprawnienia do roli',
    'routerTitleBinding-agreement': '绑车协议',
    routerTitleDownload: 'CFMOTO RIDE APP Download',
    routerTitleEbook: 'ebook',
    routerTitleIntroduce: '介绍',
    routerTitleOrderConfirm: 'Order Confirmation',
    routerTitlePdf: 'PDF',
    ru_RU: 'Rosyjski',
    safeRemind: 'Aby chronić bezpieczeństwo swojego konta, prosimy nie podawać tutaj wrażliwych danych osobowych, takich jak hasła do kont itp.',
    satelliteMap: 'Mapa satelitarna',
    saturday: 'Sobota',
    save: 'Zapisać',
    saveAndPreview: 'Zapisz i wyświetl podgląd',
    saveAsDraft: 'Zapisz jako szkic',
    saveFail: 'Zapis nie powiódł się',
    savePicture: 'Zapisz zdjęcie',
    saveSettings: 'Сачувај подешавања',
    saveSuccess: 'Pomyślne zapisanie',
    saveVideo: 'Zapisz wideo',
    scanQrcodePreview: 'Zeskanuj poniższy kod QR telefonem komórkowym, aby wyświetlić podgląd',
    screenNavigationGuidance: 'Ustawienia rozruchu',
    sdkStatement: 'Oświadczenie SDK',
    search: 'Szukaj',
    searchRecords: 'Wyszukiwanie w historii',
    secondaryMenu: 'Menu wtórne',
    securityMessage: 'Powyższe informacje są wykorzystywane tylko w celu weryfikacji tożsamości, CFMOTO chroni Twoje dane.',
    securityServices: 'Usługi bezpieczeństwa (lokalizacja w czasie rzeczywistym, strefa geograficzna, alarm awarii)',
    select: 'Wybierz',
    selectAccount: 'Wybierz konto',
    selectAll: 'Zaznacz wszystko',
    selectAuthentication: 'Wybierz uwierzytelnienie',
    selectChannelType: 'Wybierz kanał opinii',
    selectCountry: 'Wybierz kraj',
    selectData: 'Wybierz dane, które chcesz usunąć, i kliknij przycisk Prześlij na dole, aby przesłać żądanie usunięcia danych.',
    selectDate: 'Wybierz datę',
    selectEnableStatus: {},
    selectFeedBackState: 'Wybierz stan przetwarzania opinii',
    selectFeedbackType: 'Wybierz typ opinii',
    selectJumpTarget: {},
    selectLanguage: 'Proszę wybrać język',
    selectOneCarType: 'Wybierz przynajmniej jeden model',
    selectPoint: {},
    selectPopupFrequency: {},
    selectPopupPosition: {},
    selectPopupTarget: {},
    selectPopupTime: {},
    selectRejectReason: 'Wybierz powód odrzucenia',
    selectTheLanguage: 'Wybierz język',
    selectTime: 'wybierz czas',
    selectUser: 'Wybierz użytkowników',
    selectVehicle: 'Wybierz pojazd',
    selectedMileage: 'Wybrany przebieg',
    selectedMileageRedemption: 'Wybierz przebieg do wykorzystania',
    selectionOfImporter: 'Wybór importera',
    sendNumberDescription: 'Liczba prawidłowych urządzeń, dla których AWS Cloud utworzył zadania wysyłki;',
    sendNumberDescription0: 'Spośród efektywnych urządzeń docelowych, serwer Aurora faktycznie pomyślnie tworzy liczbę urządzeń do wysyłania zadań',
    sendNumberVolume: 'Liczba wysłanych wiadomości',
    sendTo: 'Wyślij do',
    sendType: 'Tryb wysyłania',
    sendUserNum: 'Liczba wysłanych wiadomości',
    sending: 'W wysyłaniu',
    serial: 'Nie.',
    seriesBackground: {},
    seriesDesc: {},
    seriesIntroduction: 'Wprowadzenie serii',
    seriesName: {},
    seriesShowcase: 'Pokaz serii',
    seriesUplodImgRule: {},
    seriousAlarm: 'Poważny alarm',
    serviceDays: 'Dni świadczenia usługi',
    serviceDetail: 'Szczegóły Inteligentnych Usług',
    serviceExpiration: 'Twoje inteligentne usługi wygasły',
    serviceHavExpired: 'Inteligentne Usługi Wygasły',
    serviceIntroduction: 'Wprowadzenie do usługi',
    serviceReset: 'Reset usługi inteligentnej',
    serviceText: 'Usługa',
    settingSuccess: 'Ustaw pomyślnie',
    shareNumber: 'Liczba akcji',
    sheet: 'Zhang',
    show: 'Zobacz',
    showPicturesOfVideos: 'Pokaż zdjęcia/filmy',
    showToast1: 'Za mało przebiegu na 1 dzień usługi',
    showToast2: 'Wymagany co najmniej 1 dzień usługi',
    showToast3: 'Parametr nie istnieje lub ma wartość pustą',
    showroomModel: 'Modele salonów wystawowych',
    showroomModelList: 'Lista modeli z salonu',
    showroomModelQuery: 'Zapytanie o model salonu',
    showroomUploadRules: 'Wymagany format obrazu to jpg/jpeg/png, współczynnik obrazu wynosi 9:19,5, rozmiar nie przekracza 5 MB, a rozmiar wideo nie przekracza 50 MB',
    signOut: 'Automatyczne zakończenie',
    singapore: 'Singapur',
    sixMonths: 'Sześć miesięcy',
    slideToRight: 'przesuń w prawo',
    smartServices: 'Inteligentne usługi',
    someUser: 'Niektórzy użytkownicy',
    sort: 'Sortuj',
    source: 'Źródło',
    sr_YU: 'serbski',
    standardAgreement: 'Status umowy Standard Edition',
    startCalculateTimeBasedata: 'Czas Resetowania Wersji Standard',
    startCalculateTimeMotoplay: 'Czas Resetowania MotoPlay',
    startChecking: 'Rozpocznij sprawdzanie',
    startTime: 'Czas rozpoczęcia',
    statisticalTime: 'Czas statystyczny',
    status: 'Status',
    stepText1: 'To ensure smooth data migration and use of the CFMOTO RIDESYNC App, we recommend that you follow these steps:',
    stepText2: '1. First, you can click the button below [Download CFMOTO RIDESYNC] or directly open Apple Store/Google Play to search and download CFMOTO RIDESYNC App;',
    stepText3: '2. After downloading and installing, please open the CFMOTO RIDESYNC App to enter the login page. On this page, you need to log in with your existing CFMOTO RIDE account and password;',
    stepText4:
      '3. When you enter your account and password correctly, the App will pop up a prompt window asking whether to start the data migration. When you click OK, the data migration starts immediately and this process is uninterrupted. If you select "Cancel" in this step, you will not be able to continue logging into the App.',
    stepText5: '4. After clicking OK, the data migration will start immediately, and the process is uninterruptable. If that fails, contact it@cfmoto.com',
    stepText6:
      '5. After the data migration is completed, you will automatically enter the vehicle homepage of the CFMOTO RIDESYNC App. At this moment, you can start to use all functions of the App normally, and you will be able to access all the data you previously retained in the CFMOTO RIDE App.',
    stepText7:
      '*Important notes: Be sure to log in the CFMOTO RIDESYNC App with your CFMOTO RIDE account to ensure successful data migration. If you choose to register a new account or log in with another account, your data will not be migrated. In addition, after successful data migration, your original CFMOTO RIDE account will no longer support login to the CFMOTO RIDE App. Please operate carefully to ensure the safe migration of your data.',
    stop: {},
    store: {},
    storeAddressCountryTip: 'Uwaga:  Ten adres sklepu jest jedyną podstawą, na której użytkownicy mogą Cię znaleźć.  Prosimy o dokładne wypełnienie i upewnienie się, że adres jest poprawny',
    storeAddressDetail: 'Adres sklepu',
    storeAddressDetailTip: 'Przykład: szczegółowy adres:  NO.116, Wuzhou Road, Yuhang Economic Development Zone, Hangzhou',
    storeAddressPosition: 'Szerokość i długość geograficzna',
    storeAddressPositionTip:
      'Długość geograficzna: część całkowita długości geograficznej to liczba całkowita od -180 do 180, a część dziesiętna to liczba dziesiętna nieprzekraczająca 15 cyfr.\nSzerokość geograficzna: część całkowita szerokości geograficznej jest liczbą całkowitą od -90 do 90, a część dziesiętna nie przekracza 15 miejsc po przecinku.',
    storeBusinessType: 'Typ sklepu',
    storeImage: 'Obraz sklepu',
    storeImportTemplateText:
      'Najpierw pobierz szablon, wypełnij informacje o sklepie dealera w pliku szablonu, a następnie prześlij plik; rozmiar pliku jest ograniczony do 1 MB; jeśli przesyłanie się nie powiedzie, zmniejsz zawartość lub prześlij partiami',
    storeIntroduce: 'Wprowadzenie do sklepu',
    storeList: 'Lista sklepów',
    storeMange: 'Zarządzanie sklepem',
    storeName: 'Nazwa sklepu',
    storeNameTip: 'Uwaga: Proszę wybrać język obsługiwany przez system w celu uzupełnienia nazwy sklepu',
    storeQueryUserStatistics: 'Statystyki zapytań użytkowników sklepu',
    storeRemarkName: 'Nazwa uwagi dotyczącej sklepu',
    storeRemarkNameTip: 'Uwaga:  Jeśli język obsługiwany przez system nie spełnia Twoich potrzeb, możesz wprowadzić tutaj nazwę uwagi sklepu w wybranym języku.',
    storeSearch: 'Zapytanie dotyczące sklepów',
    storeServicePhone: 'Numer telefonu do serwisu',
    storeServicePhoneTip: 'Uwaga: Numer ten służy do kontaktu telefonicznego z klientem. Upewnij się, że numer telefonu jest poprawny.',
    storeServiceTime: 'Czas otwarcia',
    storeStatistics: 'Statystyki sklepu',
    storeUploadImageRequire: 'Wymagania dotyczące formatu obrazu jpg/jpeg/png, zaleca się, aby rozmiar pojedynczego obrazu nie przekraczał 5 MB, pojedynczy import do 9, może być zaimportowany więcej niż raz, całkowita liczba nie więcej niż 9',
    storefront: 'Sklep',
    submissionFailed: 'Wysłanie nie powiodło się, proszę spróbować ponownie.',
    submit: 'Składać',
    submitAccountDeleteApply: 'Prześlij żądanie usunięcia konta',
    submitDataDeleteApply: 'Prześlij wniosek o usunięcie danych',
    submitFeedback: 'Prześlij opinię',
    submitForReview: 'Prześlij do przeglądu',
    submitted: 'Przesłane',
    successful: 'Udany',
    sunday: 'Niedziela',
    supportMapDown: {},
    supportedChannel: {},
    sureAgree: 'Zgadzasz się czy nie?',
    sureBackApply: 'Potwierdź wycofanie wniosku o usunięcie konta',
    sureDelete: 'Raz usuniętego nie można odzyskać. Czy na pewno chcesz to usunąć',
    sureDeleteData: 'Czy na pewno chcesz usunąć wybrane dane?  Po potwierdzeniu dane są natychmiast usuwane i nie można ich odzyskać',
    sureDeleteSeries: {},
    sureDeleteSetting: {},
    sureDeleteStoreInfo: 'Potwierdzić usunięcie informacji o sklepie? Po usunięciu informacji nie będzie można ich odzyskać.',
    sureReject: 'Czy na pewno chcesz odrzucić?',
    sureSuspend: 'Wysyłanie zostanie zatrzymane po zakończeniu. Czy na pewno chcesz zakończyć',
    suspend: 'Zakończyć',
    sv_SE: 'szwedzki',
    switchLanguage: 'Zmień język',
    system: 'System',
    systemBusy: 'System jest zajęty, spróbuj ponownie później',
    systemVersion: 'wersja systemu',
    tboxInstall: 'Instalacja Tbox po zakupie',
    tboxIntro: 'T-Box jest kluczowym urządzeniem realizującym funkcję inteligentnego połączenia sieciowego pojazdów',
    teamConfigTip: {},
    threeMonths: 'Trzy miesiące',
    thursday: 'Czwartek',
    time: 'Czas',
    timeSend: 'Wysyłanie w określonym czasie',
    timedOffline: 'Zaplanowane przejście w tryb offline',
    timedPush: 'Naciśnij na czas',
    timedRelease: 'Wydanie czasowe',
    timedSendTime: 'Wyślij czas',
    tips: 'Porady',
    title: 'tytuł',
    to: 'Do',
    toBeReleased: 'Do wydania',
    topMenu: 'Menu górne',
    topicContent: 'Treść tematu',
    topicList: 'Lista tematów',
    topicManagement: 'Zarządzanie tematem',
    topicSearch: 'Wyszukiwanie tematu',
    topicTitle: 'Tytuł tematu',
    totalAndlLayoutOfStores: 'Łączna liczba i układ sklepów',
    totalClicks: {},
    totalNumber: 'Łączna liczba razy',
    tr_TR: 'turecki',
    triggerNum: 'Liczba wyzwalaczy',
    tuesday: 'Wtorek',
    turnOn: 'Otwarty',
    twoCarAndFourCarOfNumber: 'Liczba użytkowników pojazdów dwukołowych i czterokołowych',
    twoCarOfNumber: 'Liczba użytkowników pojazdów dwukołowych',
    twoWheelConfig: {},
    twoWheeler: 'Dwukołowiec',
    twoWheelerAndFourWheeler: 'Dwukołowy i czterokołowy',
    twoWheelerMostClicks: 'Modele pojazdów dwukołowych z największą liczbą kliknięć',
    twoWheelowner: {},
    type: 'Typ',
    typeMessage: 'typ informacji zwrotnej',
    types: 'Typ',
    unbind: 'Rozwiązany',
    unbindingCommitment: {},
    unbindingLabelRealName: 'Imię i nazwisko',
    unbound: 'Bez ograniczeń',
    understandRealtimeConditions: 'Otrzymuj wibracje pojazdu i komunikaty przypominające o wjeździe i wyjeździe z elektronicznego ogrodzenia oraz poznaj stan pojazdu w czasie rzeczywistym',
    uninstallTboxDesc: 'W przypadku pojazdów, które nie są wyposażone w T-Box, po powiązaniu można wyświetlić podstawowe informacje o pojeździe, takie jak numer ramy, numer silnika i instrukcję elektroniczną.',
    unitCurrencyPer: {},
    unitMonth: 'Miesiąc',
    unlimited: 'Bez limitu',
    unpaid: {},
    unprocessed: 'Niepoddane obróbce',
    unresolved: 'Nadal nie możesz rozwiązać? Kliknij',
    unspecified: 'Poufność',
    upToTopics: 'Można dodać do %s przystanków',
    updateAuthenticationTime: 'Zaktualizuj czas uwierzytelnienia',
    updateBy: 'Aktualizator',
    updateSuccess: {},
    updateTime: 'Czas aktualizacji',
    updating: 'aktualizacja',
    upgradeAgainDescription: 'Zadanie aktualizacji zostało przesunięte ponownie. Postępuj zgodnie z 【Przewodnikiem】 na górze bieżącej strony, aby podłączyć sieć wyświetlacza TFT w celu aktualizacji.',
    upgradeAssistant: 'Pomoc',
    upgradeDescription: 'Po znalezieniu nowej wersji postępuj zgodnie z 【Przewodnikiem】 na górze bieżącej strony, aby podłączyć sieć wyświetlacza TFT w celu aktualizacji.',
    upgradeSuccessful: 'Aktualizacja zakończona sukcesem',
    upgradeType: 'Metoda aktualizacji',
    upload: 'Wgrywać',
    uploadDisplayPicture: {},
    uploadFail: 'Przesyłanie nie powiodło się',
    uploadFailed: 'Przesyłanie nie powiodło się, spróbuj użyć innej sieci',
    uploadFailedOfTry: 'Przesyłanie nie powiodło się, spróbuj ponownie',
    uploadFileMore1M: 'Rozmiar przesyłanego pliku nie przekracza 1M',
    uploadFiles: 'Prześlij plik',
    uploadImageRules1To1: 'Format obrazu musi być jpg/jpeg/png, o stosunku obrazu 1:1 i maksymalnym rozmiarze 5MB',
    uploadLog: 'Prześlij dziennik',
    uploadPicture: 'Prześlij zdjęcie',
    uploadQuantityExceed: 'Liczba załadowanych plików przekracza limit',
    uploadSuccessful: 'Przesyłanie powiodło się',
    uploadTime: 'Czas przesyłania',
    uploadTip556_740: {},
    uploadVideoRules: 'Obsługiwane jest tylko pojedyncze przesyłanie plików wideo. Zaleca się, aby rozmiar pojedynczego filmu nie przekraczał 50MB.',
    uploadVideoRules4To3: 'Obsługa formatu wideo, zalecany stosunek 4:3, rozmiar nie przekracza 50MB',
    urlLink: 'Link URL',
    user: 'Użytkownik',
    userAccount: 'Konto użytkownika',
    userEmail: 'E-mail',
    userGender: 'Płeć użytkownika',
    userId: 'Identyfikator użytkownika',
    userIdTemplate: 'Szablon importu identyfikatora użytkownika',
    userIdentity: 'Identyfikator użytkownika',
    userLocalTime: 'Czas użytkownika końcowego',
    userLogin: 'Logowanie',
    userMobilePhone: 'numer telefonu komórkowego',
    userModel: 'Model użytkownika',
    userName: 'Nazwa użytkownika',
    userName1: {},
    userNickname: 'Pseudonim użytkownika',
    userNum: 'Numer użytkownika',
    userPhone: 'numer telefonu komórkowego',
    userRealName: 'Prawdziwe imię użytkownika',
    userReply: 'Oczekiwanie na odpowiedź użytkownika',
    userStatus: 'Status użytkownika',
    userType: 'Typ użytkownika',
    userUnbind: 'Rozłączenie użytkownika',
    users: 'użytkownicy',
    vacationTime: 'Czas wakacji',
    validNumberVolume: 'Liczba prawidłowych celów',
    validNumerDescription: 'Liczba urządzeń pozostałych po odfiltrowaniu wybranej grupy docelowej dla zadania push',
    validateAfter24Hours: 'Obsługuje tylko przyszłe wybory czasu w ciągu 24 godzin',
    validateEmail: 'Nieprawidłowy format adresu e-mail, proszę sprawdzić.',
    validateImageRadio: 'Wymagania dotyczące formatu pliku obrazu:  %s, skala obrazu:  %s, nie więcej niż %s',
    validateImageSize: 'Wymagania dotyczące formatu pliku obrazu:  %s, zalecany rozmiar obrazu:  %s, nie więcej niż %s',
    validatePhone: 'Błąd formatu numeru telefonu, sprawdź',
    validateVideo: 'Wymagania dotyczące formatu pliku wideo:  %s, nie więcej niż %s',
    validateVin: 'Nieprawidłowy numer VIN, proszę sprawdzić.',
    validationCodeError: 'Błąd kodu weryfikacyjnego',
    vechicleFirstBindTime: 'Rzeczywisty pierwszy czas powiązania pojazdu',
    vehicleAlarmDetails: 'Szczegóły alarmu pojazdu',
    vehicleBindDuration: 'Czas trwania wiązania pojazdu',
    vehicleBrochure: 'Broszura pojazdu',
    vehicleColor: 'Kolor pojazdu',
    vehicleDetails: 'Szczegóły pojazdu',
    vehicleDrivingLicense: 'Dokument rejestracyjny pojazdu.',
    vehicleFaultDetails: 'Szczegóły awarii pojazdu',
    vehicleGallery: 'Galeria pojazdów',
    vehicleGalleryEntranceConfiguration: 'Wszystkie zdjęcia strony salonu motocyklowego w aplikacji i funkcji galerii pojazdów pochodzą z poniższej konfiguracji. Upewnij się, że trzy zdjęcia są kompletne w konfiguracji.',
    vehicleGalleryEntranceSettings: 'Ustawienia wejścia do galerii pojazdów',
    vehicleGalleryUploadRules: 'Wymagany format obrazu to jpg/jpeg/png. Zaleca się, aby rozmiar pojedynczego obrazu nie przekraczał 5MB. Jednocześnie można zaimportować maksymalnie 10 obrazów. Dozwolony jest wielokrotny import.',
    vehicleIdHomepageImage: 'Główna strona dokumentu rejestracyjnego pojazdu z imieniem właściciela i numerem identyfikacyjnym VIN.',
    vehicleModel: 'Model maszyny',
    vehicleModelAlbum: 'Album modelowy',
    vehicleModelCategorySort: 'Sortuj według kategorii pojazdu',
    vehicleModelDescription: 'Opis modelu',
    vehicleModelList: 'Lista modeli',
    vehicleModelManagement: 'Zarządzanie modelami pojazdów',
    vehicleModelName: 'Nazwa modelu',
    vehicleModelQuery: 'Zapytanie o model pojazdu',
    vehicleModelSeries: 'Seria modeli',
    vehicleModelSorting: 'Sortowanie modeli',
    vehicleModelType: 'Typ modelu',
    vehicleName: 'Nazwa pojazdu',
    vehicleNetworkEquipment: 'Urządzenie sieciowe pojazdu',
    vehicleOutboundCountry: 'Kraj wyjazdu',
    vehicleRemark: 'uwagi dotyczące pojazdu',
    vehicleShareInstruction: 'Instrukcje współdzielenia pojazdów',
    vehicleShareInstructionAdd: 'Nowe instrukcje współdzielenia pojazdów',
    vehicleShareInstructionEdit: 'Edytuj instrukcje współdzielenia pojazdów',
    vehicleType: 'Nr silnika',
    vehicleTypeSplicing: 'Model opinii',
    vehicleUnbindingInstructions: 'Instrukcje dotyczące ubiegania się o wyrejestrowanie pojazdu',
    verifyCodeSendFail: 'Nie udało się wysłać kodu weryfikacyjnego',
    verifyCodeSendSuccess: 'Wysyłanie kodu weryfikacyjnego powiodło się',
    versionCode: 'Numer wersji',
    versionIntroduction: 'Wersja Wprowadzenie',
    versionManage: 'Zarządzanie wersjami',
    versionManageList: 'Lista zarządzania wersjami',
    versionMangeTip:
      'Uwaga: Niedozwolone jest tworzenie wersji większej niż numer wersji aktualnie opublikowany na rynku aplikacji! Personel obsługi i konserwacji musi poczekać na udostępnienie najnowszej wersji w Google Play lub App Store, a następnie utworzyć rekordy wersji odpowiadające najnowszemu numerowi wersji. Tworzenie zapisów z wyprzedzeniem jest niedozwolone.',
    versionPattern: 'Numer wersji można wprowadzić wyłącznie jako liczbę całkowitą z zakresu od 0 do 999.',
    versionRequired: 'Numer wersji nie może być pusty',
    vhDataBasicService: 'Dane pojazdu Podstawowa usługa',
    video: 'Wideo',
    videoContent: 'Treść wideo',
    videoCover: 'Okładka wideo',
    videoDetail: 'Szczegóły wideo',
    videoDisplayImages: 'Wyświetlanie wideo',
    videoFile: 'Plik wideo',
    videoGuide: 'Konfiguracja rozruchu wideo',
    videoImageValidate: 'Wymagania dotyczące formatu pliku obrazu: png jpg jpeg, proporcje obrazu 16:9, rozmiar nie większy niż 5 MB',
    videoList: 'Lista filmów',
    videoMaxSizeValidate: 'Rozmiar filmu nie może przekraczać 150MB',
    videoSizeExceed: 'Proszę przesłać film o szerokości i wysokości %s',
    viewAllComment: 'Wyświetl wszystkie komentarze',
    viewCount: 'liczba obejrzeń',
    viewCurrentLocation: 'Otwórz aplikację, aby wyświetlić aktualną lokalizację pojazdu w dowolnym momencie',
    viewCurrentLocation2: 'Otwórz aplikację, aby w dowolnym momencie wyświetlić aktualną lokalizację pojazdu, co jest wygodne do wyszukiwania pojazdów z bliskiej odległości',
    viewDetails: 'Zobacz szczegóły',
    viewFeedBackRecords: 'Zobacz zapisy opinii',
    viewLocation: 'Otwórz aplikację, aby w dowolnym momencie sprawdzić lokalizację pojazdu',
    viewModel: {},
    viewPush: 'Wyświetl Push',
    viewSeries: {},
    viewVehicleInfomation: 'Obsługa przeglądania codziennego toru jazdy, przebiegu, czasu trwania, prędkości i innych informacji o pojeździe',
    views: 'Wyświetlenia',
    vin: 'VIN',
    virginia: 'Wirginia',
    waitForReview: 'Oczekiwanie na przegląd',
    waitUploading: 'Przesyłanie, proszę czekać',
    waitingManualReview: 'Oczekiwanie na ręczny przegląd',
    waitingOnline: {},
    waitingPush: 'Czekanie',
    wednesday: 'Środa',
    whatOTA: 'Co to jest OTA?',
    whyUseNavigation: 'Jak korzystać z nawigacji',
    whyUseSetting: 'Jak wprowadzić ogólne ustawienia aplikacji',
    withCountry: 'Kraj/region (IP)',
    withInformation: 'Zawierające informacje',
    withTBOX: {},
    withdrawn: 'Wycofany',
    withoutCarOfNumber: 'Liczba użytkowników bez samochodu',
    withoutTBOX: {},
    writeAccountToPass: 'Wypełnij informacje o koncie i dokończ weryfikację tożsamości',
    year: {},
    yes: 'tak',
    youHaveFeedbackMessage: 'Masz ** opinie użytkowników, które nie zostały skutecznie uwzględnione, zajmij się nimi na czas',
    youthVehicleOwner: {},
    yoyGrowth: 'Zwiększono o  Rok do roku',
    zh_CN: 'chiński',
  },
};
